import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';

import { Form, FormikProps } from 'formik';
import { TextField, Typography } from '@material-ui/core';

import Recovery from './Recovery';

const Login: React.FunctionComponent<FormikProps<LoginFormValues>> = ({
	isSubmitting,
	touched,
	errors,
	values,
	handleBlur,
	handleChange,
}) => {
	const { t } = useTranslation();
	const classes = useStyles();

	const [showForgot, setShowForgot] = useState(false);

	return (
		<Form className={classes.form}>
			<TextField
				fullWidth={true}
				type="text"
				name="username"
				onChange={handleChange('username')}
				onBlur={handleBlur('username')}
				value={values.username}
				variant="outlined"
				label={t('common:username')}
				className={classes.input}
			/>
			{!!touched['username'] && !!errors['username'] && (
				<Typography variant="button" color="error">
					{errors['username']}
				</Typography>
			)}
			<TextField
				fullWidth={true}
				type="password"
				name="password"
				onChange={handleChange('password')}
				onBlur={handleBlur('password')}
				value={values.password}
				variant="outlined"
				label={t('common:password')}
				className={classes.input}
			/>
			{!!touched['password'] && !!errors['password'] && (
				<Typography variant="button" color="error">
					{errors['password']}
				</Typography>
			)}
			{isSubmitting && <LinearProgress />}
			<Button type="submit" fullWidth variant="contained" color="primary" className={classes.forgot}>
				{t('system:login')}
			</Button>
			<Button
				type="button"
				fullWidth
				variant="contained"
				color="secondary"
				className={classes.forgot}
				onClick={() => setShowForgot(true)}
			>
				{t('system:forgot')}
			</Button>
			{showForgot && <Recovery onClose={() => setShowForgot(false)} />}
		</Form>
	);
};

const useStyles = makeStyles((theme) => ({
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	forgot: {
		marginTop: theme.spacing(1),
	},
	input: {
		marginTop: theme.spacing(2),
	},
}));

export default Login;
